import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import { Box } from '@mui/system'
import InfoIcon from 'assets/icons-gray/info.svg'
import { useModal } from 'react-modal-hook'
import InfoModal, { infoModalKind } from './Modal/InfoModal'

const Image = styled.img`
  width: 16px;
  height: 16px;
  padding: 1px;
  cursor: pointer;
  :hover {
    background-color: rgba(18, 18, 18, 0.08);
    border-radius: 100%;
  }
`

interface Props {
  kind: infoModalKind
  text?: string
  width?: string
  variant?: Variant
}
const InfoTip = ({ kind, text, width, variant }: Props) => {
  const [showModal, hideModal] = useModal(() => (
    <InfoModal kind={kind} onClose={hideModal} />
  ))
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width,
      }}
    >
      {text && (
        <Typography
          variant={variant ? variant : 'body2'}
          sx={{ padding: '0px 4px 0px 0px' }}
        >
          {text}
        </Typography>
      )}
      <Image src={InfoIcon} alt="info-icon" onClick={showModal} />
    </Box>
  )
}

export default InfoTip
